import { CSSProperties } from 'react';

import Box from './Box';
import NovaCircle from './NovaCircle';

import Theme from '../../../styles/Theme/Theme';

type TProps = {
    circleTop?: boolean;
    circleTopColor?: keyof typeof Theme.color;
    circleBottom?: boolean;
    circleBottomColor?: keyof typeof Theme.color;
    children: React.ReactNode;
};

const BackgroundWrapper = ({ circleTop, circleBottom, children, circleTopColor, circleBottomColor, height }: TProps & CSSProperties) => {
    return (
        <Box as="section" position="relative" zIndex="0" height={height ? height : "auto"}>
            {circleTop && <NovaCircle size={200} customPosition="top-right" customColor={circleTopColor} />}
            {circleBottom && <NovaCircle size={200} customPosition="bottom-left" customColor={circleBottomColor ? circleBottomColor : 'green-nova-1'} />}
            {children}
        </Box>
    );
};

export default BackgroundWrapper;
